import React from "react";
import { PageOne, PageTwo, Form, OTP, PageFour } from "components/pages";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { withRouter } from "react-router-dom";
import VerifyComplete from "./VerifyComplete";
import { useStep } from "context/stepContext";

const Create = () => {
  const { step } = useStep();
  switch (step) {
    case 1:
      return (
        <Grid item container sx={{ justifyContent: "center" }}>
          <PageOne />
        </Grid>
      );
    case 2:
      return (
        <Grid item container sx={{ justifyContent: "center", padding: "2rem" }}>
          <PageTwo />
        </Grid>
      );
    case 3:
      return (
        <Grid item container sx={{ justifyContent: "center", padding: "2rem" }}>
          <Form />
        </Grid>
      );
    case 4:
      return (
        <Grid item container sx={{ justifyContent: "center", padding: "1rem" }}>
          <PageFour />
        </Grid>
      );

    case 5:
      return (
        <Grid item container sx={{ justifyContent: "center", padding: "1rem" }}>
          <VerifyComplete />
        </Grid>
      );
    case 6:
      return (
        <Grid item container sx={{ justifyContent: "center", padding: "1rem" }}>
          <OTP />
        </Grid>
      );
    default:
      <PageOne />;
      break;
  }
};
Create.propTypes = {
  handleNext: PropTypes.func,
};

export default withRouter(Create);
